

export interface IStrandCodes {
  speed: {
    value: string;
    actual: string;
    sp: string;
  };
  mouldCooling: {
    flow: {
      actual: string;
      aimed: string;
    },
    temperature: {
      in: string;
      out: string;
      delta: string;
    }
  };
  sprayCooling: {
    zone1: {
      flow: {
        sp: string;
        actual: string;
      },
      pressure: string;
    },
    zone2: {
      flow: {
        sp: string;
        actual: string;
      },
      pressure: string;
    },
    zone3: {
      flow: {
        sp: string;
        actual: string;
      },
      pressure: string;
    },
    zone4: {
      flow: {
        sp: string;
        actual: string;
      },
      pressure: string;
    }
  };
  cutter: {
    withdrawal: string;
    straightener: string;
    length: {
      actual: string;
      totalCasted: string;
      remaining: string;
      totalCut: string;
    }
  }
}

export interface IRightPaneCodes {
  superHeat: {
    value: string;
    min: string;
    max: string;
    aim: string;
  },
  turretArmWeight: string;
  speed: string;
  liquidusTemperature: string;
  tundish: {
    temperature: string;
    netWeight: string;
  }
}

export interface ICastingFloorCodes {
  ladleTurret: {
    a1Weight: string;
    a2Weight: string;
  };
  tundish: {
    netWeight: string;
    tareWeight: string;
    grossWeight: string;
    sp: string;
    totalTonCast: string;
  };
  currentHeat: {
    actual: string;
    grade: string;
  }
}


export const variables = [
  "MS.CASTER1.SPRAY.COOLING.STR04.Z2.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR05.Z2.FLOW_ACTUAL",
  "MS.CASTER1.MS.CAST.TURRET.ARM_IN_CAST_WEIGHT",
  "MS.CASTER1.SPRAY.COOLING.STR04.Z1.PRESSURE_ACTUAL",
  "MS.CASTER1.CUTTER.LENGTH.STR04.TOTAL_CUT",
  "MS.CASTER1.CUTTER.LENGTH.STR04.REMAINING_LENGTH",
  "MS.CASTER1.CUTTER.LENGTH.STR04.TOTAL_CASTED_LENGTH",
  "MS.CASTER1.CUTTER.LENGTH.STR04.ACTUAL_LEN",
  "MS.CASTER1.SPRAY.COOLING.STR05.Z1.PRESSURE_ACTUAL",
  "MS.CASTER1.CUTTER.LENGTH.STR05.TOTAL_CUT",
  "MS.CASTER1.CUTTER.LENGTH.STR05.REMAINING_LENGTH",
  "MS.CASTER1.CUTTER.LENGTH.STR05.TOTAL_CASTED_LENGTH",
  "MS.CASTER1.CUTTER.LENGTH.STR05.ACTUAL_LEN",
  "CASTER01.HORNO_VOLTAJE_PRIMARIO",
  "MS.CASTER1.SPRAY.COOLING.STR04.Z1.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR04.Z1.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR04.Z2.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR04.Z3.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR04.Z2.PRESSURE_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR04.Z3.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR04.Z3.PRESSURE_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR04.Z4.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR04.Z4.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR04.Z4.PRESSURE_ACTUAL",
  "MS.CASTER1.MOULD.COOLING.STR04.FLOW_ACTUAL",
  "MS.CASTER1.MOULD.COOLING.STR04.FLOW_AIME",
  "MS.CASTER1.MOULD.COOLING.STR04.TEMP_IN",
  "MS.CASTER1.MOULD.COOLING.STR04.TEMP_OUT",
  "MS.CASTER1.MOULD.COOLING.STR04.TEMP_DELTA_T",
  "MS.CASTER1.SPRAY.COOLING.STR05.Z1.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR05.Z1.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR05.Z2.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR05.Z3.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR05.Z2.PRESSURE_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR05.Z3.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR05.Z3.PRESSURE_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR05.Z4.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR05.Z4.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR05.Z4.PRESSURE_ACTUAL",
  "MS.CASTER1.MOULD.COOLING.STR05.FLOW_ACTUAL",
  "MS.CASTER1.MOULD.COOLING.STR05.FLOW_AIME",
  "MS.CASTER1.MOULD.COOLING.STR05.TEMP_IN",
  "MS.CASTER1.MOULD.COOLING.STR05.TEMP_OUT",
  "MS.CASTER1.MOULD.COOLING.STR05.TEMP_DELTA_T",
  "CASTER01.HORNO_ELECTRODO_1_CENTRO",
  "MS.CASTER1.MOULD.LEVEL.STR04.SPEED_ACTUAL",
  "MS.CASTER1.MOULD.LEVEL.STR04.ACTUAL",
  "MS.CASTER1.MOULD.LEVEL.STR04.SP",
  "MS.CASTER1.MOULD.LEVEL.STR05.SPEED_ACTUAL",
  "MS.CASTER1.MOULD.LEVEL.STR05.ACTUAL",
  "MS.CASTER1.MOULD.LEVEL.STR05.SP",
  "MS.CASTER1.OSC.STR04.MOTOR_POSITION_ACTUAL",
  "MS.CASTER1.OSC.STR05.MOTOR_POSITION_ACTUAL",
  "MS.CASTER1.STR04.OSC.MOTOR_POSITION_SP",
  "MS.CASTER1.STR05.OSC.MOTOR_POSITION_SP",
  "MS.CASTER1.SPRAY.COOLING.STR03.Z4.PRESSURE_ACTUAL",
  "MS.CASTER1.CUTTER.LENGTH.STR03.ACTUAL_LEN",
  "MS.CASTER1.CUTTER.LENGTH.STR03.TOTAL_CASTED_LENGTH",
  "MS.CASTER1.CUTTER.LENGTH.STR03.REMAINING_LENGTH",
  "MS.CASTER1.CUTTER.LENGTH.STR03.TOTAL_CUT",
  "MS.CASTER1.SPRAY.COOLING.STR03.Z1.PRESSURE_ACTUAL",
  "MS.CASTER1.MOULD.COOLING.STR03.FLOW_ACTUAL",
  "MS.CASTER1.MOULD.COOLING.STR03.FLOW_AIME",
  "MS.CASTER1.MOULD.COOLING.STR03.TEMP_IN",
  "MS.CASTER1.MOULD.COOLING.STR03.TEMP_OUT",
  "MS.CASTER1.MOULD.COOLING.STR03.TEMP_DELTA_T",
  "MS.CASTER1.SPRAY.COOLING.STR03.Z1.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR03.Z1.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR03.Z2.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR03.Z3.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR03.Z2.PRESSURE_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR03.Z3.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR03.Z2.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR03.Z3.PRESSURE_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR03.Z4.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR03.Z4.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR01.Z1.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR01.Z1.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR01.Z2.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR01.Z3.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR01.Z2.PRESSURE_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR01.Z3.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR01.Z2.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR01.Z3.PRESSURE_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR01.Z4.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR01.Z4.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR01.Z4.PRESSURE_ACTUAL",
  "MS.CASTER1.CUTTER.LENGTH.STR01.ACTUAL_LEN",
  "MS.CASTER1.CUTTER.LENGTH.STR01.TOTAL_CASTED_LENGTH",
  "MS.CASTER1.CUTTER.LENGTH.STR01.REMAINING_LENGTH",
  "MS.CASTER1.CUTTER.LENGTH.STR01.TOTAL_CUT",
  "MS.CASTER1.SPRAY.COOLING.STR01.Z1.PRESSURE_ACTUAL",
  "MS.CASTER1.STR02.OSC.MOTOR_POSITION_SP",
  "MS.CASTER1.OSC.STR02.MOTOR_POSITION_ACTUAL",
  "MS.CASTER1.MOULD.LEVEL.STR02.SP",
  "MS.CASTER1.MOULD.LEVEL.STR02.ACTUAL",
  "MS.CASTER1.MOULD.LEVEL.STR02.SPEED_ACTUAL",
  "MS.CASTER1.MOULD.COOLING.STR02.FLOW_ACTUAL",
  "MS.CASTER1.MOULD.COOLING.STR02.FLOW_AIME",
  "MS.CASTER1.MOULD.COOLING.STR02.TEMP_IN",
  "MS.CASTER1.MOULD.COOLING.STR02.TEMP_OUT",
  "MS.CASTER1.MOULD.COOLING.STR02.TEMP_DELTA_T",
  "MS.CASTER1.SPRAY.COOLING.STR02.Z1.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR02.Z1.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR02.Z2.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR02.Z3.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR02.Z2.PRESSURE_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR02.Z3.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR02.Z2.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR02.Z3.PRESSURE_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR02.Z4.FLOW_SP",
  "MS.CASTER1.SPRAY.COOLING.STR02.Z4.FLOW_ACTUAL",
  "MS.CASTER1.SPRAY.COOLING.STR02.Z4.PRESSURE_ACTUAL",
  "MS.CASTER1.CUTTER.LENGTH.STR02.ACTUAL_LEN",
  "MS.CASTER1.CUTTER.LENGTH.STR02.TOTAL_CASTED_LENGTH",
  "MS.CASTER1.CUTTER.LENGTH.STR02.REMAINING_LENGTH",
  "MS.CASTER1.CUTTER.LENGTH.STR02.TOTAL_CUT",
  "MS.CASTER1.SPRAY.COOLING.STR02.Z1.PRESSURE_ACTUAL",
  "MS.CASTER1.STR03.OSC.MOTOR_POSITION_SP",
  "MS.CASTER1.OSC.STR03.MOTOR_POSITION_ACTUAL",
  "MS.CASTER1.MOULD.LEVEL.STR03.SP",
  "MS.CASTER1.MOULD.LEVEL.STR03.ACTUAL",
  "MS.CASTER1.MOULD.LEVEL.STR03.SPEED_ACTUAL",
  "MS.CASTER1.MS.CAST.TURRET.A1.GROSS_WEIGHT",
  "MS.CASTER1.MS.CAST.TURRET.A2.GROSS_WEIGHT",
  "MS.CASTER1.HEAT.ACTUAL",
  "MS.CASTER1.HEAT.ACTUAL_GRADE",
  "MS.CASTER1.TUNDISH.TARE_WEIGHT",
  "MS.CASTER1.TUNDISH.GROSS_WEIGHT",
  "MS.CASTER1.TUNDISH.NET_WEIGHT",
  "MS.CASTER1.TUNDISH.STEEL_WEIGHT_SP",
  "MS.CASTER1.TUNDISH.TOTAL_TON_CAST",
  "MS.CASTER1.TUNDISH.STEEL_TEMPERATURE",
  "MS.CASTER1.TURRET.ARM_IN_CAST_WEIGHT",
  "MS.CASTER1.TUNDISH.NET_WEIGHT",
  "MS.CASTER1.TUNDISH.STEEL_TEMPERATURE",
  "MS.CASTER1.QA.N2.SUPER_HEAT_LIQUIDUS_TEMPERATURE",
  "MS.CASTER1.STR01.OSC.MOTOR_POSITION_SP",
  "MS.CASTER1.OSC.STR01.MOTOR_POSITION_ACTUAL",
  "MS.CASTER1.MOULD.LEVEL.STR01.SP",
  "MS.CASTER1.MOULD.LEVEL.STR01.ACTUAL",
  "MS.CASTER1.MOULD.LEVEL.STR01.SPEED_ACTUAL",
  "MS.CASTER1.MOULD.COOLING.STR01.FLOW_ACTUAL",
  "MS.CASTER1.MOULD.COOLING.STR01.FLOW_AIME",
  "MS.CASTER1.MOULD.COOLING.STR01.TEMP_IN",
  "MS.CASTER1.MOULD.COOLING.STR01.TEMP_OUT",
  "MS.CASTER1.MOULD.COOLING.STR01.TEMP_DELTA_T",
  "MS.CASTER1.WITHDRAWAL.STR01.ACTUAL_PRESSURE",
  "MS.CASTER1.WITHDRAWAL.STR02.ACTUAL_PRESSURE",
  "MS.CASTER1.WITHDRAWAL.STR03.ACTUAL_PRESSURE",
  "MS.CASTER1.WITHDRAWAL.STR04.ACTUAL_PRESSURE",
  "MS.CASTER1.WITHDRAWAL.STR05.ACTUAL_PRESSURE",
  "MS.CASTER1.STRAIGHTENER.STR01.ACTUAL_PRESSURE",
  "MS.CASTER1.STRAIGHTENER.STR02.ACTUAL_PRESSURE",
  "MS.CASTER1.STRAIGHTENER.STR03.ACTUAL_PRESSURE",
  "MS.CASTER1.STRAIGHTENER.STR04.ACTUAL_PRESSURE",
  "MS.CASTER1.STRAIGHTENER.STR05.ACTUAL_PRESSURE",
  "MS.CASTER1.N2.SUPER_HEAT_MIN",
  "MS.CASTER1.N2.SUPER_HEAT_MAX",
  "MS.CASTER1.N2.SUPER_HEAT_AIM",
  "MS.CASTER1.TURRET.A1.GROSS_WEIGHT",
  "MS.CASTER1.TURRET.A2.GROSS_WEIGHT",
  "MS.CASTER1.N2.SUPER_HEAT_SPEED_GOAL",
  "MS.CASTER1.AUTO_SUPER_HEAT"
];